@if (document(); as i) {
    <div
        [class.lock]="lock"
        [class]="
            isActive()
                ? 'cursor-pointer border-primary bg-primary-50'
                : 'cursor-pointer border-gray-200 bg-white'
        "
        (click)="handleDetail()"
        class="transition-all duration-200 p-4 flex gap-3 rounded-xl items-center justify-between border select-none hover:shadow-md hover:-translate-y-0.5 hover:scale-[1.01]"
    >
        <div class="flex flex-col gap-0.5">
            <div class="flex gap-2 items-center">
                @if (i.template; as template) {
                    <p class="text-gray-800 font-medium">{{ template.name }}</p>
                } @else {
                    <p class="text-gray-800 font-medium">
                        {{ etcType[i.etcType] }}
                    </p>
                }
                @if (lock) {
                    <app-icon
                        name="material-symbols:lock"
                        class="text-primary !size-4"
                    />
                }
            </div>

            @if (status() === "COMPLETED") {
                <div class="flex gap-2 items-center">
                    <p class="text-xs text-gray-500">최종 작성일</p>
                    <div class="h-2 w-px bg-gray-300"></div>
                    <p class="text-xs text-gray-500">
                        {{ i.updatedAt | date: "y.MM.dd HH:mm" }}
                    </p>
                </div>
            } @else {
                <p class="text-xs text-gray-500">작성 대기</p>
            }
        </div>
        @if (status() === "COMPLETED") {
            <div class="flex items-center justify-center">
                <app-icon
                    name="material-symbols:check-circle"
                    class="!size-6 text-green-500"
                />
            </div>
        }
    </div>
}
